import InternalRequestStatusHint from 'domains/internal-request/components/internal-request-status-hint'
import OutboundInternalRequestsApiV2 from 'api/v2/admins/outbound-internal-requests-api-v2'
import { getInternalRequestListUrlState, syncInternalRequestListUrl } from 'domains/internal-request/services/internal-request-list-url-state'
import TitlePage from 'components/atoms/title-page'
import { ARCHIVE_STATUS } from 'domains/internal-request/constants'
import InternalRequestTable from 'domains/internal-request/organisms/table'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import {
  Card,
  CardBody
} from 'reactstrap'


const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const InternalRequestRequestorArchiveListPage = ({ pageUtils }) => {
  const [ internalRequests, setInternalRequests ] = useState([])
  const [ pagination, setPagination ]             = useState({})
  const history                                   = useHistory()
  const location                                  = useLocation()
  const initialUrlState                           = getInternalRequestListUrlState(location.search)
  const [ isLoading, setIsLoading ]               = useState(true)

  const handleFetchInternalRequests = useCallback(async (tableState) => {
    syncInternalRequestListUrl({
      history,
      pathname      : window.location.pathname,
      currentSearch : window.location.search,
      tableState
    })

    setIsLoading(true)

    let additionalFilters = {}

    /**
     * We check whether user has been filtering by status columns.
     * if so, we don't need to use `additionalFilter`
     */
    const statusFilter = tableState.filters.find((filter) => filter.id === 'status')

    if (!statusFilter || statusFilter?.value?.length === 0) {
      additionalFilters = {
        status: [
          ARCHIVE_STATUS.COMPLETED,
          ARCHIVE_STATUS.CANCELLED
        ]
      }
    }

    await OutboundInternalRequestsApiV2.index({ tableState, additionalFilters })
      .then((response) => {
        setInternalRequests(response.data.internal_requests)
        setPagination(response.data.meta)
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally( () => setIsLoading(false) )
  }, [ history, pageUtils ])

  /**
   * Handler to redirect to archive detail page
   * @param {object} datum - selected row record
   */
  const handleSelectRow = useCallback((datum) => {
    const { id } = datum

    history.push({
      pathname: `archive/${id}`
    })
  }, [ history ])

  /**
   * Disable view detail button for cancelled Internal Request
   * @param {object} datum - selected row record
   */
  const isDisabledViewDetail = useCallback((datum) => {
    const { status } = datum

    return status === ARCHIVE_STATUS.CANCELLED ? true : false
  }, [])

  return (
    <>
      <TitlePage mainTitle='Internal Requests' subTitle='Borrowed History' />

      <Card>
        <CardBody>
          <InternalRequestStatusHint audience='requestor' />
          <InternalRequestTable
            categoryStatus={ ARCHIVE_STATUS }
            data={ internalRequests }
            pagination={ pagination }
            isLoading={ isLoading }
            initialFilter={ initialUrlState.filters }
            initialPageIndex={ initialUrlState.pageIndex }
            initialPageSize={ initialUrlState.pageSize }
            onFetchData={ handleFetchInternalRequests }
            rowButtonProps={{
              buttonText       : 'Detail',
              onButtonClick    : handleSelectRow,
              isButtonDisabled : isDisabledViewDetail
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}

InternalRequestRequestorArchiveListPage.propTypes = propTypes

export default InternalRequestRequestorArchiveListPage
